import {Group} from "react-konva";
import type {AreaEffect} from "@/encounter/model/AreaEffect.ts";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import {useAreaEffectInteraction} from "./AreaEffectInteractionHooks.ts";
import AreaEffectAppearance from "./AreaEffectAppearance.tsx";

/** GM input wrapper around the effect artwork. */
export default function AreaEffectView({effect}: {effect: AreaEffect}) {
    const {combatants} = useCombatants();
    const {isSelected, handleMouseDown} = useAreaEffectInteraction(effect);
    const combatant = combatants.find(candidate => candidate.id === effect.combatantId);
    return <Group onMouseDown={handleMouseDown} listening={!combatant}>
        <AreaEffectAppearance effect={effect} combatant={combatant} selected={isSelected}/>
    </Group>;
}
